var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListInput',_vm._g(_vm._b({key:("number-" + _vm.required),attrs:{"name":"number","type":"number","validation":_vm.validationParams,"required":_vm.required}},'ListInput',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }